"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import PartialFetcher from "./partial_fetcher";
import Refetcher from "./data/entity/refetcher";
import LoadsStore from "../stores/loads_store";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import DataStoreService from "./data_store_service";
import { storeChangedEvent } from "../stores/object_with_id_store";
class LoadsService {
  constructor() {
    __publicField(this, "_store", LoadsStore);
    __publicField(this, "_invoiceStore", CarrierInvoicesStore);
    __publicField(this, "loads", []);
    __publicField(this, "loads_by_carrier_id", {});
    __publicField(this, "counts", {
      approved: 0
    });
    __publicField(this, "fetched");
    __publicField(this, "fetchingPromise");
    __publicField(this, "ready", () => {
      if (this.fetched) {
        return Promise.resolve(true);
      } else if (this.fetchingPromise) {
        return this.fetchingPromise;
      } else {
        this.fetchingPromise = Promise.resolve().then(() => {
          return $.get("/api/loads/to_process").then((data) => {
            this.fetched = true;
            return DataStoreService.updateStores(data);
          });
        });
        return this.fetchingPromise.then(() => {
          this.fetchingPromise = null;
        });
      }
    });
    __publicField(this, "partialFetcher", new PartialFetcher(this._store, function(ids) {
      return $.get("/api/loads/bulk", { ids }).then(function(result) {
        return DataStoreService.updateStores(result).loads;
      });
    }));
    __publicField(this, "getFetchedWithId", (loadStateId) => {
      return this._store.find(loadStateId);
    });
    __publicField(this, "loadsUpdated", () => {
      this.counts.approved = this.approved().length;
    });
    __publicField(this, "update", () => {
      this.fetcher.update();
    });
    __publicField(this, "fetcher", new Refetcher(
      "/api/loads/updates",
      DataStoreService.responseHandler
    ));
    window.ls = this;
    $(this._store).on(storeChangedEvent("loadState"), this.loadsUpdated);
  }
  refresh() {
    this.fetched = false;
    return this.ready();
  }
  allLoads() {
    return this._store.items;
  }
  approved() {
    return _.sortBy(
      // LoadState doesn't declare state or processed_at
      _.where(this.allLoads(), { state: "processed" }),
      function(load) {
        var processed_at = load.processed_at;
        if (!processed_at) {
          processed_at = /* @__PURE__ */ new Date("01/01/1900");
        } else {
          processed_at = new Date(processed_at);
        }
        return Date.now() - processed_at.getTime();
      }
    );
  }
  getLoads(loadStateIds) {
    return this.partialFetcher.fetchItemsIfNeeded(loadStateIds);
  }
  getLoadsByInvoiceIds(invoiceIds) {
    var loadStateIds = _.pluck(
      _.compact(this._invoiceStore.findAll(invoiceIds)),
      "load_state_id"
    );
    return _.map(loadStateIds, this.getFetchedWithId);
  }
  getLoad(loadStateId) {
    return this.getLoads([loadStateId]).then(function(loads) {
      return _.first(loads);
    });
  }
  forceGetLoad(loadStateId) {
    return this.forceGetLoads([loadStateId]).then(function(loads) {
      return _.first(loads);
    });
  }
  forceGetLoads(loadStateIds) {
    return this.partialFetcher.fetchItemsIfNeeded(
      loadStateIds,
      (item) => false
    );
  }
}
var loadsService = new LoadsService();
export default loadsService;
